// extracted by mini-css-extract-plugin
export var Wrapper = "PrivacyPolicyContent-module--Wrapper--3-MUI";
export var HeaderWrapper = "PrivacyPolicyContent-module--HeaderWrapper--1IF4E";
export var Article = "PrivacyPolicyContent-module--Article--1UE0B";